let ymapsPromise = null;

/**
 * Загрузка Яндекс.Карт 2.1 (один раз на страницу).
 * @param {string} [apiKey]
 */
export const loadYandexMaps = (apiKey = '') => {
    if (typeof window === 'undefined') {
        return Promise.reject(new Error('no window'));
    }

    if (window.ymaps?.ready) {
        return new Promise(resolve => {
            window.ymaps.ready(() => resolve(window.ymaps));
        });
    }

    if (ymapsPromise) {
        return ymapsPromise;
    }

    ymapsPromise = new Promise((resolve, reject) => {
        const existing = document.querySelector(
            'script[data-tm-ymaps="1"]'
        );
        if (existing && window.ymaps) {
            window.ymaps.ready(() => resolve(window.ymaps));
            return;
        }

        const params = new URLSearchParams({
            lang: 'ru_RU'
        });
        if (apiKey) {
            params.set('apikey', apiKey);
        }

        const script = document.createElement('script');
        script.dataset.tmYmaps = '1';
        script.src = `https://api-maps.yandex.ru/2.1/?${params.toString()}`;
        script.async = true;
        script.onload = () => {
            if (!window.ymaps) {
                reject(new Error('ymaps not available'));
                return;
            }
            window.ymaps.ready(() => resolve(window.ymaps));
        };
        script.onerror = () => {
            ymapsPromise = null;
            reject(new Error('Не удалось загрузить Яндекс.Карты'));
        };
        document.head.appendChild(script);
    });

    return ymapsPromise;
};

export const getTaskCoordinates = task => {
    const coords = task?.meta?.coordinates;
    const lat = Number(coords?.lat);
    const lon = Number(coords?.lon);
    if (
        Number.isFinite(lat) &&
        Number.isFinite(lon) &&
        Math.abs(lat) <= 90 &&
        Math.abs(lon) <= 180
    ) {
        return [lat, lon];
    }
    return null;
};

/** Заявка на генератор (по тексту WO / названию / типу). */
export const isGeneratorTask = task => {
    const parts = [
        task?.title,
        task?.description,
        task?.news_type_name,
        task?.task_number
    ];

    (task?.fields || []).forEach(field => {
        if (field?.value == null) {
            return;
        }
        if (typeof field.value === 'string') {
            parts.push(field.value);
        }
    });

    const hay = parts
        .map(value =>
            String(value || '')
                .toLowerCase()
                .replace(/ё/g, 'е')
        )
        .join(' ');

    return /генератор/.test(hay);
};
